import * as React from 'react'
import * as Redux from 'react-redux'
import { styled } from 'next-yak'

import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

import { RootState } from '../../../../reducers'
import * as modalAction from '../../../../actions/modal'
import * as modalReducer from '../../../../reducers/modals/paymentDisturbanceModal'

import { TRACKING_SOURCE } from '../utils/trackerEnums'

import { FollowProjectButton } from './FollowProjectButton'

type PaymentDisturbanceModalProps = {
  className?: string
}

function PaymentDisturbanceModalComponent({ className }: PaymentDisturbanceModalProps): React.ReactElement<any> {
  const dispatch = Redux.useDispatch()

  const modal = Redux.useSelector<RootState, modalReducer.State>((state) => state.application.paymentDisturbanceModal)
  const handleClosing = (): void => {
    dispatch(modalAction.toggleModalPaymentDisturbance(false))
  }

  return (
    <plume.ModalWithIcon
      className={className}
      open={modal.open}
      closable={true}
      onClose={handleClosing}
      icon={<plume.illustrations.twoToned.WarningSign size={120} />}
      svgScale={0.88}
    >
      <plume.styles.heading.S>{t('Payment temporarily unavailable')}</plume.styles.heading.S>
      <plume.styles.copy.M.light>
        {t(
          'Due to a technical maintenance of our payment provider, we are obliged to suspend all payments tonight on our platform.',
        )}
      </plume.styles.copy.M.light>
      <plume.styles.copy.M.light>
        {t('You will be able to contribute to this project again from 7am (Paris time).')}
      </plume.styles.copy.M.light>
      <plume.styles.copy.M.light>
        {t('We invite you to subscribe to the project to receive posts and back it later.')}
      </plume.styles.copy.M.light>
      <CTAWrapper>
        <FollowProjectButton source={TRACKING_SOURCE.PAYMENT_DISTURBANCE} />
        <plume.LinkAsButton kind="secondary" onClick={handleClosing}>
          {t('Close this window')}
        </plume.LinkAsButton>
      </CTAWrapper>
    </plume.ModalWithIcon>
  )
}

export const PaymentDisturbanceModal = styled(PaymentDisturbanceModalComponent)`
  ${plume.styles.modal.Body} {
    display: flex;
    flex-direction: column;
  }

  ${plume.styles.heading.S} {
    text-align: left;
    margin: 15px 0;
  }

  ${plume.styles.copy.M.light} {
    text-align: left;
    margin-bottom: 25px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${plume.styles.modal.Wrapper} {
      max-width: 390px;
    }
  }
`

export const CTAWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;

  ${plume.LinkAsButton} {
    display: block;
    margin: 0 auto;
    width: fit-content;
  }
`
